<template>
	<div class="event__booking-form grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-4 vue-styles" data-event-id="">
		<div class="col-span-3 flex justify-center items-center py-10 min-h-[887px]" v-if="loading">
			<Spinner />
		</div>

		<div class="lg:col-span-2 text-sub max-w-[818px]" v-if="!loading">
			<div class="mb-8" v-if="store.view_only.value && successContent && bookingUuid !== '' && successful" v-html="successContent" />

			<template v-if="!successful">
				<h2 class="text-red">An error has occurred</h2>

				<p v-if="!successful" class="text-red font-bold !mb-4">We are sorry that an error has occurred with the payment. You are welcome to try and make this purchase again. If you continue to experience issues, please contact us by emailing <a href="mailto:office@acc-uk.org">office@acc-uk.org</a>.</p>
			</template>

			<event-booking-form :event-id="eventId" :event-booking-id="bookingUuid" />
		</div>

		<div class="flex flex-col" v-if="!loading">
			<div class="sticky top-4">
				<booking-details />

				<event-details />
			</div>
		</div>
	</div>
</template>

<script setup>
	import store from './state/store'
	import BookingDetails from './components/summary/BookingDetails.vue'
	import EventDetails from './components/summary/EventDetails.vue'
	import Spinner from '../components/loading/Spinner.vue'
	import EventBookingForm from './components/form/Form.vue'
	import { computed, onBeforeMount } from 'vue'
    import populateFormFromData from "@app/booking/state/partials/helpers/populateFormFromData.js"

	const props = defineProps({
		eventId: {
			type: String,
			required: true,
		},
		bookingUuid: {
			type: String,
			required: false,
			default: "",
		},
	})

    onBeforeMount(() => {
        store.data.event_booking.api.parameters.value.booking_uuid = props.bookingUuid
        store.data.event.api.parameters.value.event_id = props.eventId
        
        if(props.bookingUuid){
            Promise.all([
                store.data.event.api.execute(),
                store.data.event_booking.api.execute()
            ]).then(
                () => populateFormFromData()
            )
        } else {
            store.data.event.api.execute()
        }
    })

	const successContent = computed(
		() => phpVals.acc.events.successMessage
	)

	const loading = computed(
		() => store.data.event.loading.value
			|| store.data.user.loading.value
			|| store.data.event_booking.loading.value
	)

	const successful = computed(() => !!parseInt((new URL(location)).searchParams.get('success') ?? 1))
</script>